import api from '@/libs/axios'
import { cleanEntityToSend } from '../../utils/form'
import Vue from 'vue'
import ToastificationContent from '@/components/toastification/ToastificationContent.vue'
import { capitalize } from '@/utils/filter'
import i18n from '@/libs/i18n'
import store from '@/store'

export default {
  getBankStatements ({ commit }) {
    return new Promise((resolve, reject) => {
      api.get('/bankStatements')
        .then(response => {
          commit('SET_BANKSTATEMENTS', response.data)
          resolve(response)
        })
        .catch(err => {
          console.log('Error', err)
          reject(err)
        })
    })
  },
  async addBankStatement ({ commit, state }, bankStatement) {
    return await cleanEntityToSend(bankStatement, state.params)
      .then(async clonedEntityToSend => {
        return new Promise((resolve, reject) => {
          api.post('/bankStatements', clonedEntityToSend)
            .then(response => {
              commit('ADD_BANKSTATEMENT', response.data)

              Vue.$toast({
                component: ToastificationContent,
                props: {
                  title: capitalize(i18n.t('success')),
                  icon: 'check',
                  text: i18n.t('The bankStatement has been ', { crud: i18n.t('createdE') }),
                  variant: 'success'
                },
              })

              resolve(response)
            })
            .catch(error => {
              console.log('Error', error)
              reject(error)
            })
        })

      })
      .catch(error => {
        console.log('Error', error)
        reject(error)
      })
  },
  async updateBankStatement ({ commit, state }, bankStatement) {
    return await cleanEntityToSend(bankStatement, state.params)
      .then(async clonedEntityToSend => {

        return new Promise((resolve, reject) => {
          api.put('/bankStatements/' + bankStatement.id, clonedEntityToSend)
            .then(response => {
              commit('UPDATE_BANKSTATEMENT', response.data)

              Vue.$toast({
                component: ToastificationContent,
                props: {
                  title: capitalize(i18n.t('success')),
                  icon: 'check',
                  text: i18n.t('The bankStatement has been ', { crud: i18n.t('editedE') }),
                  variant: 'success'
                },
              })

              resolve(response)
              // resolve(JSON.parse(JSON.stringify(response)))
            })
            .catch(error => {
              console.log('Error', error)
              reject(error)
            })
        })

      })
      .catch(error => {
        console.log('Error', error)
        reject(error)
      })
  },
  removeBankStatement ({ commit }, bankStatement) {
    return new Promise((resolve, reject) => {
      api.delete('/bankStatements/' + bankStatement.id)
        .then(response => {
          commit('REMOVE_BANKSTATEMENT', bankStatement)

          Vue.$toast({
            component: ToastificationContent,
            props: {
              title: capitalize(i18n.t('success')),
              icon: 'check',
              text: i18n.t('The bankStatement has been ', { crud: i18n.t('removed') }),
              variant: 'success'
            },
          })

          resolve(response)
        })
        .catch(error => {
          console.log('Error', error)
          reject(error)
        })
    })
  },

}